import { TravelExpense } from '../../lib/types/models/travel-expenses/travel-expenses'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getAffectedStaffTravelExpenses(id: number) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.getAffectedStaffTravelExpenses.url, { id }))
    .get<TravelExpense[]>()
}
